// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2478":"ec2e3383","3282":"4ddec837","8750":"81844405"}[chunkId] + ".chunk.css";
};